import { BaseLayer } from '.'
import { api } from '@/api'
import type { FeatureCollection, Feature, Point } from 'geojson'
import { Subscriber } from 'cesium-extends'
import EquipPopup from '@/views/Map/Popup/EquipPopup.vue'
import { BillboardGraphics, Cartographic, Math as CMath, NearFarScalar } from 'cesium'
import equipSvgUri from '@/assets/equip.svg?url'
export class EquipLayer extends BaseLayer {
  layername: string = '设备'
  key: string = 'equip'
  constructor() {
    super()
    this.once('mounted', (viewer) => {
      this._subscriber = new Subscriber(viewer, { pickResult: { enable: true } })
    })
  }
  async render() {
    await this.datasource.load(await this.loadGeojson())
    // assignHeight(this.datasource.entities.values, this._viewer!)
    this.datasource.entities.values.forEach((entity) => {
      entity.billboard = new BillboardGraphics({
        image: equipSvgUri,
        scaleByDistance: new NearFarScalar(1e3, 1, 3e4, 0.2),
        disableDepthTestDistance: 3000000,
      })
    })
    this._subscriber?.add(
      this.datasource.entities.values,
      (_e, substance) => {
        const viewer = this._viewer
        if (!viewer || !substance) return
        const position = substance.position?.getValue()
        if (!position) return
        const cartographic = Cartographic.fromCartesian(position)
        this.popupCtrl.popup({
          viewer,
          id: substance.id,
          Com: EquipPopup,
          lnglat: [cartographic.longitude, cartographic.latitude].map(CMath.toDegrees) as [
            number,
            number,
          ],
          properties: substance.properties?.getValue(),
        })
      },
      'LEFT_CLICK'
    )
  }
  private async loadGeojson(): Promise<FeatureCollection> {
    const res = await api.equipment.equipmentControllerGetEquipmentList()
    const featureCollection: FeatureCollection<Point> = {
      type: 'FeatureCollection',
      features: [],
    }
    res.data.forEach((el) => {
      const { masterLatitude, masterLongitude, ...properties } = el
      const feature: Feature<Point> = {
        type: 'Feature',
        id: properties.equipmentId,
        geometry: { type: 'Point', coordinates: [masterLongitude, masterLatitude].map(Number) },
        properties: properties,
      }
      featureCollection!.features.push(feature)
    })
    return featureCollection
  }
}
